var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title1, visible: _vm.outerVisible, width: "1300px" },
      on: {
        close: function ($event) {
          _vm.outerVisible = false
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _vm._l(_vm.titleData, function (col) {
            return col.query == 1
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-left": "10px",
                      "margin-bottom": "10px",
                    },
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "el-form-item-label" },
                      [
                        _vm._v(
                          _vm._s(col.name ? col.name : col.title) +
                            "\n          "
                        ),
                        col.type !== "Date"
                          ? _c("el-input", {
                              staticClass: "filter-item",
                              staticStyle: { width: "185px" },
                              attrs: { clearable: "", placeholder: "请输入" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.crud.toQuery($event)
                                },
                              },
                              model: {
                                value: _vm.query[col.title],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, col.title, $$v)
                                },
                                expression: "query[col.title]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        col.type === "Date"
                          ? _c("el-date-picker", {
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.query[col.title],
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, col.title, $$v)
                                },
                                expression: "query[col.title]",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("rrOperation", { attrs: { crud: _vm.crud } }),
        ],
        2
      ),
      _vm._v(" "),
      _c("crudOperation", { attrs: { permission: _vm.permission } }),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { "margin-bottom": "20px", "margin-top": "30px" },
          attrs: { gutter: 20 },
        },
        [
          _c("el-col", { attrs: { span: 12, offset: 10 } }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      size: "mini",
                      type: "success",
                      icon: "el-icon-search",
                    },
                    on: { click: _vm.crud.toQuery },
                  },
                  [_vm._v("搜索")]
                ),
                _vm._v(" "),
                _vm.crud.optShow.reset
                  ? _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: {
                          size: "mini",
                          type: "warning",
                          icon: "el-icon-refresh-left",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resetQuery()
                          },
                        },
                      },
                      [_vm._v("重置")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title2,
            visible: _vm.innerVisible,
            width: "1300px",
            "append-to-body": "",
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function ($event) {
              _vm.innerVisible = $event
            },
          },
        },
        [
          _c("crudOperation", { attrs: { permission: _vm.permission } }),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.crud.loading,
                  expression: "crud.loading",
                },
                {
                  name: "sticky",
                  rawName: "v-sticky",
                  value: { top: 0 },
                  expression: "{ top: 0 }",
                },
              ],
              staticClass: "sticky-head",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.crud.data,
                "header-cell-style": {
                  background: "#f6f7fa",
                  color: "#606266",
                },
                "max-height": "800",
              },
            },
            _vm._l(_vm.title2Data, function (col) {
              return _c("el-table-column", {
                attrs: {
                  prop: col.title,
                  label: col.name ? col.name : col.title,
                  "min-width": col.width ? col.width : 120,
                  "show-overflow-tooltip": "true",
                  "column-key": col.title,
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("pagination"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "div",
            { attrs: { id: "table-content" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.crud.loading,
                      expression: "crud.loading",
                    },
                    {
                      name: "sticky",
                      rawName: "v-sticky",
                      value: { top: 0 },
                      expression: "{ top: 0 }",
                    },
                  ],
                  staticClass: "sticky-head",
                  staticStyle: { width: "100%", height: "500px" },
                  attrs: {
                    border: "",
                    data: _vm.crud.data,
                    "header-cell-style": {
                      background: "#f6f7fa",
                      color: "#606266",
                    },
                    "max-height": "800",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", width: "50" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.titleData, function (col) {
                    return _c("el-table-column", {
                      attrs: {
                        prop: col.title,
                        label: col.name ? col.name : col.title,
                        "min-width": col.width ? col.width : 120,
                        "show-overflow-tooltip": "true",
                        "column-key": col.title,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                col.penetrate == 1
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            ;(_vm.outerVisible = true),
                                              _vm.openSubreportByInner(
                                                col.subreport,
                                                col.subreportParams,
                                                scope.row
                                              )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row[col.title]))]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row[col.title] || "-")
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }